import { rem } from 'polished';
import styled from 'styled-components';
import { BodyText, CounsellorProfile, Icon } from '@unmind/design-system';

export const StyledCounsellorProfile = styled(CounsellorProfile)`
  clear: both;
  margin-bottom: ${rem(20)};
`;

export const StyledAppointment = styled.div`
  display: flex;
  gap: ${rem(8)};
  align-items: center;
  justify-content: space-between;
`;

export const StyledAppointmentType = styled(BodyText).attrs(({ theme }) => ({
  sizes: [theme.typography.fontSizes.fontSize14],
  weight: theme.typography.fontWeights.medium,
  color: theme.colors.text.primary,
}))`
  display: flex;
  gap: ${rem(4)};
  align-items: center;

  a {
    color: inherit;
    text-decoration: underline;
  }
`;

export const AppointmentIcon = styled(Icon)`
  margin-right: ${rem(4)};
`;

export const StyledPill = styled.span`
  display: inline-block;
  width: fit-content;
  background-color: ${({ theme }) =>
    theme.colors.book.appointmentCards.pill.background};
  border-radius: ${rem(6)};
  padding: ${rem(6)};
  font-size: ${rem(14)};
  font-weight: 500;
  margin-bottom: ${rem(20)};
`;
